import state from './accessState.js'
import actions from './accessActions.js'
import mutations from './accessMutations.js'
import getters from './accessGetters.js'

export default {
  state,
  getters,
  actions,
  mutations,
}
